
import {
    createToken,
    refreshToken,
    getAuth,
	loginWithKakao,
	connectWithKakao,
	loginWithGoogle,
	connectWithGoogle,
    loginWithApple,
    connectWithApple,
    checkPassword,
    retry
} from "../apis/api_auth";

import {
    changeUserPhone,
    changeUserPhoneCheck,
    secessionUser,

    createUser,
    createUserCheck,
    changeUserPw,
    changeUserPwCheck,
} from "../apis/api_user";

import { 
    login,
    logout,
    setAxiosDefaultsHeadersCommonAuthorizationRefreshToken,
    getBearerToken
} from '../utils/auth'

import router from '../router'

const state = {
    item: {
        id:0,
        name:'',
        phone:'',
        recentLoginDt:'',

        social: null,

        bookingAlarmCount: 0,
    },
    
    itemWrite: {
        name:'',
        gender: '',
        phone:'',
        password:'',
        termsServiceYn:'N',
        termsPrivacyYn:'N',
        termsMarketingYn:'N',
    },
};

const getters = {

};

const mutations = {
    SET_AUTH(state, payload) {
        state.item.id = payload.id;
        state.item.name = payload.name;
        state.item.phone = payload.phone;
        state.item.recentLoginDt = payload.recentLoginDt;
        state.item.social = payload.social;
    },

    SET_AUTH_SOCIAL(state, social){
        state.item.social = social;
    },

    SET_AUTH_BOOKING_ALARM_COUNT(state, count) {
        state.item.bookingAlarmCount = count;
    },

    SET_AUTH_WRITE(state, user) {
        state.itemWrite.name = user.name;
        state.itemWrite.phone = user.phone;
        state.itemWrite.recentLoginDt = user.recentLoginDt
    },

    CLEAR_AUTH(state) {
        state.item = {
            id:0,
            name:'',
            phone:'',
            recentLoginDt:'',
            social: null,
            bookingAlarmCount: 0,
        };
    },

    CLEAR_AUTH_WRITE(state) {
        state.itemWrite = {
            name:'',
            gender: '',
            phone:'',
            password:'',
            termsServiceYn:'N',
            termsPrivacyYn:'N',
            termsMarketingYn:'N',
        };
    },

};

const actions = {


    async LOGIN(context, { username, password }) {
        try {

            // let formData = new FormData();
            // formData.append('username', username);
            // formData.append('password', password);

            const response = await createToken({ username, password });

            login({ 
                token: response.data.data.token,
                refreshToken: response.data.data.refreshToken
            });

            await context.dispatch('GET_AUTH')

            return response.data.data;

        } catch (e) {
            return Promise.reject(e);
        }
    },

    async LOGIN_REFRESH({ commit }, originalRequest) {
        try {

            setAxiosDefaultsHeadersCommonAuthorizationRefreshToken();

            const response = await refreshToken();
            
            login({ 
                token: response.data.data.tokenData.token,
                refreshToken: response.data.data.tokenData.refreshToken
            });

            originalRequest.headers['Authorization'] = getBearerToken();

            commit('SET_AUTH', response.data.data)

            return retry(originalRequest);
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async LOGOUT({ commit }) {
        try {
            commit('CLEAR_AUTH');
            logout();
            return true;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async LOGOUT_EXPIRE(context) {
        try {

            await context.dispatch('LOGOUT')

            context.commit('OPEN_MODAL', {
                content:'세션이 만료되어 로그아웃 됩니다. 다시 로그인해 주세요.',
                btnOne:'확인',
                btnOneSubmit: () => {
                    router.push('/login');
                },
            })
            


            return true; 
        } catch (e) {
            return Promise.reject(e);
        }
    },  

    async GET_AUTH(context) {
        try {

            const response = await getAuth();

            if (response.data.data != null) 
                context.commit('SET_AUTH', response.data.data);

            else
                context.dispatch('LOGOUT')

            return response.data.data;
        } catch (e) {
            context.dispatch('LOGOUT')
            return Promise.reject(e);
        }
    },

    async LOGIN_WITH_KAKAO({commit}, auth) {
        try {
            const response = await loginWithKakao({ auth });
            
            login({ 
                token: response.data.data.tokenData.token,
                refreshToken: response.data.data.tokenData.refreshToken
            });

            commit('SET_AUTH', response.data.data)

            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }

    },

    async CONNECT_WITH_KAKAO({commit}, auth) {
        try {
            const response = await connectWithKakao({ auth });
            commit('SET_AUTH_SOCIAL', response.data.data);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }

    },

    async LOGIN_WITH_GOOGLE({commit}, auth) {
        try {
            const response = await loginWithGoogle({ auth });

            login({ 
                token: response.data.data.tokenData.token,
                refreshToken: response.data.data.tokenData.refreshToken
            });

            commit('SET_AUTH', response.data.data)
                
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CONNECT_WITH_GOOGLE({commit}, auth) {
        try {
            const response = await connectWithGoogle({ auth });
            commit('SET_AUTH_SOCIAL', response.data.data);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async LOGIN_WITH_APPLE({commit}, auth) {
        try {
            const response = await loginWithApple({ auth });

            login({ 
                token: response.data.data.tokenData.token,
                refreshToken: response.data.data.tokenData.refreshToken
            });

            commit('SET_AUTH', response.data.data)
                
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CONNECT_WITH_APPLE({commit}, auth) {
        try {
            const response = await connectWithApple({ auth });
            commit('SET_AUTH_SOCIAL', response.data.data);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },






    async CREATE_USER({ commit }, user) {
        try {

            const response = await createUser(user);
            
            login({ 
                token: response.data.data.tokenData.token,
                refreshToken: response.data.data.tokenData.refreshToken
            });

            commit('SET_AUTH', response.data.data)

            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },

    async CREATE_USER_CHECK(context, phone) {
        try {
            const response = await createUserCheck({ phone });
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },
    
    async CHANGE_USER_PW({ commit }, { phone, password }) {
        try {
            const response = await changeUserPw({ phone, password });
            commit('CLEAR_AUTH_WRITE');
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },

    async CHANGE_USER_PW_CHECK(context, phone) {
        try {
            const response = await changeUserPwCheck({ phone });
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },


    async CHANGE_USER_PHPNE(context, { inputPhone, phone }) {
        try {
            const response = await changeUserPhone({ inputPhone, phone });
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },

    async CHANGE_USER_PHPNE_CHECK(context, phone) {
        try {
            const response = await changeUserPhoneCheck({ phone });
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },

    async CHECK_AUTH_PASSWORD(context, { password }) {
        try {
            const response = await checkPassword({ password });
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },

    async SECESSION() {
        try {
            const response = await secessionUser();
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },

};

export default {mutations, state, actions, getters};